module.exports = __webpack_public_path__ + "assets/img/noCaptch-en.529b59e6.png";